const AiAgentList = () =>
  import(/* webpackChunkName: "AiAgentList" */ 'src/components/Dashboard/Views/AiAgents/AiAgentList.vue');

const AiAgentEdit = () =>
  import(/* webpackChunkName: "AiAgentEdit" */ 'src/components/Dashboard/Views/AiAgents/AiAgentEdit.vue');

export const aiAgentRoutes = [
  {
    path: 'ai-agents/add/',
    name: 'Create AI Agent',
    component: AiAgentEdit,
  },
  {
    path: 'ai-agents/edit/:id',
    name: 'Edit AI Agent',
    component: AiAgentEdit,
  },
  {
    path: 'ai-agents/list/',
    name: 'List AI Agents',
    component: AiAgentList,
  },
];
